import { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import api from '../services/api';

export default function Perfis() {
  const [perfis, setPerfis] = useState([]);
  const [permissoes, setPermissoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editId, setEditId] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [form, setForm] = useState({ nome: '', descricao: '', permissoes: [] });

  const carregar = () => {
    Promise.all([api.get('/perfis'), api.get('/perfis/permissoes')])
      .then(([p, pm]) => { setPerfis(p.data); setPermissoes(pm.data); })
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => { carregar(); }, []);

  const limpar = () => { setForm({ nome: '', descricao: '', permissoes: [] }); setEditId(null); };

  const togglePerm = (nome) => {
    setForm(f => ({
      ...f,
      permissoes: f.permissoes.includes(nome)
        ? f.permissoes.filter(p => p !== nome)
        : [...f.permissoes, nome],
    }));
  };

  const salvar = async (e) => {
    e.preventDefault();
    setSalvando(true);
    try {
      if (editId) {
        await api.put(`/perfis/${editId}`, form);
        Swal.fire({ icon: 'success', title: 'Perfil atualizado!', timer: 1500, showConfirmButton: false });
      } else {
        await api.post('/perfis', form);
        Swal.fire({ icon: 'success', title: 'Perfil criado!', timer: 1500, showConfirmButton: false });
      }
      limpar();
      carregar();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.error || 'Erro ao salvar' });
    } finally { setSalvando(false); }
  };

  const editar = (p) => {
    setForm({ nome: p.nome, descricao: p.descricao || '', permissoes: p.permissoes || [] });
    setEditId(p.id);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const grupos = [...new Set(permissoes.map(p => p.grupo))];

  if (loading) return (
    <div className="d-flex justify-content-center py-5">
      <div className="spinner-border" style={{ color: 'var(--primary)' }}></div>
    </div>
  );

  return (
    <div>
      <h4 className="fw-bold mb-4">
        <i className="bi bi-shield-check me-2" style={{ color: 'var(--primary)' }}></i>
        Perfis e Permissões
      </h4>

      <div className="row g-4">
        {/* Formulário */}
        <div className="col-12 col-lg-7">
          <div className="card p-4">
            <h6 className="fw-bold mb-3" style={{ color: 'var(--primary)' }}>
              <i className={`bi ${editId ? 'bi-pencil' : 'bi-plus-circle'} me-2`}></i>
              {editId ? 'Editar perfil' : 'Novo perfil'}
            </h6>
            <form onSubmit={salvar}>
              <div className="row g-3 mb-3">
                <div className="col-12 col-md-5">
                  <label className="form-label fw-semibold" style={{ fontSize: '0.88rem' }}>Nome *</label>
                  <input
                    className="form-control"
                    value={form.nome}
                    onChange={e => setForm({ ...form, nome: e.target.value })}
                    required
                  />
                </div>
                <div className="col-12 col-md-7">
                  <label className="form-label fw-semibold" style={{ fontSize: '0.88rem' }}>Descrição</label>
                  <input
                    className="form-control"
                    value={form.descricao}
                    onChange={e => setForm({ ...form, descricao: e.target.value })}
                  />
                </div>
              </div>

              <div className="p-3 rounded-3 mb-4" style={{ background: '#f8f9fa', border: '1px solid #e9ecef' }}>
                <label className="form-label fw-semibold mb-3" style={{ fontSize: '0.88rem' }}>Permissões</label>
                {grupos.map(g => (
                  <div key={g} className="mb-3">
                    <div className="fw-semibold mb-2" style={{ fontSize: '0.75rem', color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{g}</div>
                    <div className="d-flex flex-wrap gap-2">
                      {permissoes.filter(p => p.grupo === g).map(p => {
                        const ativa = form.permissoes.includes(p.nome);
                        return (
                          <div
                            key={p.nome}
                            className="d-flex align-items-center gap-1 px-2 py-1 rounded"
                            style={{
                              fontSize: '0.85rem',
                              cursor: 'pointer',
                              background: ativa ? 'var(--primary-light)' : '#fff',
                              border: `1px solid ${ativa ? 'var(--primary)' : '#ddd'}`,
                              color: ativa ? 'var(--primary)' : '#666',
                            }}
                            onClick={() => togglePerm(p.nome)}
                          >
                            <input
                              type="checkbox"
                              className="form-check-input"
                              style={{ margin: 0 }}
                              checked={ativa}
                              onChange={() => togglePerm(p.nome)}
                            />
                            {p.descricao || p.nome}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>

              <div className="d-flex gap-2">
                <button type="submit" className="btn-primary-arq" disabled={salvando}>
                  {salvando ? 'Salvando...' : 'Salvar'}
                </button>
                {editId && (
                  <button type="button" className="btn-outline-arq" onClick={limpar}>Cancelar</button>
                )}
              </div>
            </form>
          </div>
        </div>

        {/* Lista de perfis */}
        <div className="col-12 col-lg-5">
          {perfis.map(p => (
            <div key={p.id} className="card p-3 mb-3">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <h6 className="fw-bold mb-0">{p.nome}</h6>
                <button className="btn btn-sm btn-link p-0" onClick={() => editar(p)} title="Editar">
                  <i className="bi bi-pencil" style={{ color: 'var(--primary)' }}></i>
                </button>
              </div>
              {p.descricao && (
                <div className="text-muted mb-2" style={{ fontSize: '0.82rem' }}>{p.descricao}</div>
              )}
              <div className="d-flex flex-wrap gap-1">
                {p.permissoes?.length > 0 ? p.permissoes.map(perm => (
                  <span key={perm} className="badge-filial" style={{ fontSize: '0.75rem' }}>{perm}</span>
                )) : (
                  <span className="text-muted" style={{ fontSize: '0.82rem' }}>Sem permissões</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
